export default "__VITE_ASSET__BrV1s3Bm__"